import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { signal } from 'cerebral/tags'
import { Banner } from './Banner'
import { Latest } from './Latest'
import { css } from 'aphrodite'
import styles from './styles'

export default connect(
  {
    hideTreeMenu: signal`startPage.hideTreeMenu`
  },
  class StartPage extends Component {
    componentDidMount() {
      const { hideTreeMenu } = this.props
      hideTreeMenu()
    }
    render() {
      return (
        <div className={css(styles.background)}>
          <Banner />
          <Latest />
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/StartPage/startPage.js